import React from 'react';
import { Container } from 'react-bootstrap';
import { FiShield } from 'react-icons/fi';
import SearchBar from './SearchBar';
import HeroMedia from './HeroMedia';

export default function Hero({ categories, onSearch, onStartQuiz }) {
  return (
    <section className="mm-hero" id="top">
      <HeroMedia />

      <Container className="mm-hero__content">
        <span className="mm-hero__badge">
          <span className="mm-hero__badge-icon" aria-hidden="true">
            <FiShield size={15} />
          </span>
          Every therapist independently verified
        </span>

        <h1 className="mm-display mm-hero__title">
          Find your qualified therapist,{' '}
          <span className="mm-accent">the easier way.</span>
        </h1>

        <p className="mm-lead mm-hero__sub">
          Search verified psychologists, psychiatrists and counsellors by what
          you&rsquo;re actually going through &mdash; not by guesswork.
        </p>

        <SearchBar categories={categories} onSearch={onSearch} />

        {/* A button, not a link: it opens a dialog rather than going anywhere,
            and an anchor here would promise a destination and a back button
            that don't exist. */}
        <p className="mm-quiz-cta">
          Not sure where to start?{' '}
          <button type="button" onClick={onStartQuiz}>
            Take the 2-minute match quiz
          </button>
        </p>
      </Container>
    </section>
  );
}
